import { API_END_POINTS } from "../../constant/config";
import axios from 'axios';
import { GET_SHOPIFY_MERCHANTS, GET_WIX_MERCHANTS, GET_WP_MERCHANTS, RESET_LOADING, GET_SINGLE_WIX_MERCHANT, GET_SINGLE_WP_MERCHANT, UPDATE_WIX_MERCHANT, UPDATE_WP_MERCHANT, SEND_EMAIL, GET_BIGCOMMERCE_MERCHANTS, GET_PORTAL_MERCHANTS, GET_SINGLE_BC_MERCHANT, UPDATE_BC_MERCHANT, CREATE_PORTAL_MERCHANT, GET_SINGLE_PORTAL_MERCHANT,UPDATE_PORTAL_MERCHANT, DELETE_PORTAL_MERCHANT } from "../type";
import Filter from "../../utils/Filter";

export const fetchWixMerchants = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_WIX_MERCHANTS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}&status=${(query.pluginStatus && query.pluginStatus!= undefined) ? query.pluginStatus : ''}`;
        const response = await axios.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.docs,query);
        dispatch({
            type: GET_WIX_MERCHANTS,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const fetchWpMerchants = (query) => async (dispatch) => {
    try {
        
        const apiEndpoint = `${API_END_POINTS.FETCH_WP_MERCHANTS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}&status=${(query.pluginStatus && query.pluginStatus!= undefined) ? query.pluginStatus : ''}`;
        const response = await axios.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.docs,query);
        dispatch({
            type: GET_WP_MERCHANTS,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const fetchSingleWixMerchant = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_WIX_MERCHANT;
        const response = await axios.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_WIX_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const fetchSingleWpMerchant = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_WP_MERCHANT;
        const response = await axios.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_WP_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const fetchSingleBcMerchant = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_BC_MERCHANT;
        const response = await axios.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_BC_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const updateWixMerchant = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_WIX_MERCHANT;
        const response = await axios.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_WIX_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_WIX_MERCHANT,
                payload: error.response.data,
            });
        }
    }
};

export const updateWpMerchant = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_WP_MERCHANT;
        const response = await axios.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_WP_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_WP_MERCHANT,
                payload: error.response.data,
            });
        }
    }
};

export const updateBcMerchant = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_BC_MERCHANT;
        const response = await axios.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_BC_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_BC_MERCHANT,
                payload: error.response.data,
            });
        }
    }
};

export const sendEmail = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.SEND_EMAIL;
        const response = await axios.get(`${apiEndpoint}/${id}`,)
        return dispatch({
            type: SEND_EMAIL,
            payload: response.data.data,
        });
        
    } catch (error) {
        console.log("error", error);
    }
};

export const resetLoading = () => async (dispatch) => {
    try {
      dispatch({
        type: RESET_LOADING,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

export const fetchShopifyMerchants = (query) => async (dispatch) => {
    try {
        console.log(query)
        const apiEndpoint = `${API_END_POINTS.FETCH_SHOPIFY_MERCHANTS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}&status=${(query.pluginStatus && query.pluginStatus!= undefined) ? query.pluginStatus : ''}`;
        const response = await axios.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.data.docs,query);
        dispatch({
            type: GET_SHOPIFY_MERCHANTS,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const fetchBigcommerceMerchants = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_BC_MERCHANTS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}&status=${(query.pluginStatus && query.pluginStatus!= undefined) ? query.pluginStatus : ''}`;
        const response = await axios.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.docs,query);
        dispatch({
            type: GET_BIGCOMMERCE_MERCHANTS,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const fetchPortalMerchants = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_PORTAL_MERCHANTS}?page=${query.pageNumber}&limit=${query.pageSize}&search=${query.search}&status=${(query.pluginStatus && query.pluginStatus!= undefined) ? query.pluginStatus : ''}`;
        const response = await axios.get(`${apiEndpoint}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.docs,query);
        dispatch({
            type: GET_PORTAL_MERCHANTS,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const exportMerchats = (url) => async (dispatch) => {
    try {
        const apiEndpoint = `${url}`;
        const response = await axios.get(`${apiEndpoint}`)
        return dispatch({
            type: "EXPORT_MERCHANT",
            payload: response,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const createPortalMerchant = (data) => async (dispatch) => {

    let formData = new FormData();
    formData.append("firstname", data.firstname);
    formData.append("lastname", data.lastname);
    formData.append("username", data.username);
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("rpassword", data.rpassword);
    formData.append("status", data.status);

    let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
    }
    
    try {
        const apiEndpoint = API_END_POINTS.CREATE_PORTAL_MERCHANTS;
        const response = await axios.post(`${apiEndpoint}`, formData, config)
        console.log(response, "response")
        return dispatch({
            type: CREATE_PORTAL_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
        if (error.response) {
            return dispatch({
                type: CREATE_PORTAL_MERCHANT,
                payload: error.response.data,
            });
        }
    }
};

export const fetchSinglePortalMerchant = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_PORTAL_MERCHANTS;
        const response = await axios.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_PORTAL_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

export const updatePortalMerchant = (data, id) => async (dispatch) => {

    let formData = new FormData();
    formData.append("firstname", data.firstname);
    formData.append("lastname", data.lastname);
    formData.append("username", data.username);
    formData.append("email", data.email);
    formData.append("password", data.password);
    formData.append("rpassword", data.rpassword);
    formData.append("status", data.status);

    let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
    }

    try {
        const apiEndpoint = API_END_POINTS.UPDATE_PORTAL_MERCHANTS;
        const response = await axios.post(`${apiEndpoint}/${id}`, formData, config)
        return dispatch({
            type: UPDATE_PORTAL_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_PORTAL_MERCHANT,
                payload: error.response.data,
            });
        }
    }
};

export const deletePortalMerchant = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_PORTAL_MERCHANTS;
        const response = await axios.delete(`${apiEndpoint}/${id}`)
        console.log(response, "response")
        return dispatch({
            type: DELETE_PORTAL_MERCHANT,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
        if (error.response) {
            return dispatch({
                type: DELETE_PORTAL_MERCHANT,
                payload: error.response.data,
            });
        }
    }
};

export const checkEmailExists = (email) => async (dispatch) => {
    let formData = new FormData();
    formData.append("search", email);

    let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
    }

    try {
        const apiEndpoint = API_END_POINTS.CHECK_EMAIL_EXIST;
        const response = await axios.post(`${apiEndpoint}`,formData, config)
        return dispatch({
            type: "CHECK_EMAIL_EXIST",
            payload: response,
        });
    } catch (error) {
        console.log("error", error);
    }
};


export const checkUsernameExists = (username) => async (dispatch) => {
    let formData = new FormData();
    formData.append("search", username);

    let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
    }

    try {
        const apiEndpoint = API_END_POINTS.CHECK_USERNAME_EXIST;
        const response = await axios.post(`${apiEndpoint}`,formData, config)
        return dispatch({
            type: "CHECK_USERNAME_EXIST",
            payload: response,
        });
    } catch (error) {
        console.log("error", error);
    }
};
